<script>
import moment from "moment-business-days";
import { mapActions } from "vuex";
import { event } from "vue-analytics";
import scrollMixin from "@/mixins/scrollMixin";
import paymentValidators from "@/utils/validators/payments";

export default {
  mixins: [scrollMixin],
  props: {
    payable: {
      type: Object,
      required: true
    },
    preloader: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    acceptBoleto() {
      let startsAt =
        this.payable.type === "cycles"
          ? this.payable.starts_at
          : this.payable.schedule_event.starts_at;

      return paymentValidators.canPayViaBoleto(this.payable.type, startsAt);
    },

    labelDaysToPay() {
      return paymentValidators.labelDaysToPay();
    },

    choosePayment(type) {
      event("cliente", "click", `Compra:Pagamento:${type}`);
      this.$emit("selected", type);
    }
  }
};
</script>

<template>
  <div>
    <div class="sub-title pt-15">
      Escolha sua forma de pagamento
    </div>

    <div class="btn-group mt-20 mb-10">
      <div
        class="btn bg-pink choose-payment"
        @click="choosePayment('credit_card');scrollTo('.flags')"
      >
        CARTÃO DE CRÉDITO
      </div>
      <div
        class="btn choose-payment"
        :class="{'btn-pink': acceptBoleto(), 'btn-disabled': !acceptBoleto(), 'btn--loading': preloader}"
        @click="choosePayment('boleto')"
      >
        <span>GERAR BOLETO</span>
      </div>
    </div>
    
    <div
      v-if="!acceptBoleto()"
      class="warning"
    >Opção de boleto indisponível pois você selecionou uma limpeza com menos de {{labelDaysToPay()}} de antecedência.</div>
  </div>
</template>

<style scoped>
.sub-title {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.italic {
  font-weight: 300;
  font-style: italic;
  font-size: 16px;
  color: #999;
  text-transform: lowercase;
}

.btn.choose-payment {
  width: 50%;
  height: 35px;
  font-size: 14px;
  font-weight: 500;
}

.warning {
  border-left: 1px solid var(--pink);
  color: var(--pink);
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin: 10px 5px 0;
  padding: 3px 7px;
}

.btn-group {
  display: flex;
  justify-content: center;
}

.btn-group .btn {
  margin: 0 5px;
}

@media (max-width: 768px) {
  .sub-title {
    display: flex;
    flex-direction: column;
  }

  .italic {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .btn {
    width: calc(100% - 42px) !important;
    margin: 5px 0 !important;
  }
  .btn.choose-payment {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/ChoosePayment.vue